export default __webpack_public_path__ + "static/media/Alex.9d9cdd3a.png";